// extracted by mini-css-extract-plugin
module.exports = {"phoneAppointmentModalRoot":"index-phoneAppointmentModalRoot-2JKps"};